import styled from 'styled-components';

export const StyledParagraph = styled.p`
  width: ${({ theme }) => theme.size.short_medium};
  text-wrap: normal;
  font-size: ${({ theme }) => theme.font.size.xsmall};
`;
